import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 } from "reactstrap";
import { Container, Row, Col } from "reactstrap";

import { getVistasTree, postPermisos } from "../requests/req-system";
import { getIdUsuario, notifica } from "../requests/utils";
const AdminVistas = (props) => {
  const { className, visible, onClosed, data } = props;
  const [tree, setTree] = useState([]);
  const [values, setValues] = useState([]);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    let unmonnted = false;
    if (data.idPerfil) {
      getTree();
    }
    if (unmonnted) {
      setDisabled(false);
      setTree([]);
      setValues([]);
      return;
    }

    return () => {
      unmonnted = true;
    };
  }, [props]);

  const getTree = async () => {
    let response = await getVistasTree(data.idPerfil);
    if (response.code === 0) {
      setTree(response.data);
      let values_ = [];
      for (let index = 0; index < response.data.length; index++) {
        const element = response.data[index];
        if (element.data.checked_) {
          values_.push(element.data.idVista);
        }
        for (let index = 0; index < element.children.length; index++) {
          const element_ = element.children[index];
          if (element_.data.checked_) {
            values_.push(element_.data.idVista);
          }
        }
      }
      setValues(values_);
    }
  };
  const toggle = () => {
    setDisabled(false);
    setTree([]);
    setValues([]);
    onClosed();
  };

  const chequed_ = (id) => {
    let newArray = values;
    if (newArray && newArray.includes(id)) {
      const index = newArray.indexOf(id);
      let newState = newArray.filter((v, i) => {
        if (i !== index) {
          return v;
        }
      });
      setValues(newState);
    } else {
      newArray = newArray.concat(id);
      setValues(newArray);
    }
  };

  const OnSubmit = async () => {
    setDisabled(true);

    let _ids = [];
    let idUsuarioAct = getIdUsuario();
    tree.forEach((element) => {
      _ids.push({
        idVista: element.data.idVista,
        idPerfil: data.idPerfil,
        idEstatus: values.includes(element.data.idVista),
        idUsuarioAct,
      });
      element.children.forEach((item) => {
        _ids.push({
          idVista: item.data.idVista,
          idPerfil: data.idPerfil,
          idEstatus: values.includes(item.data.idVista),
          idUsuarioAct,
        });
      });
    });
    let response_ = await postPermisos(_ids);
    if (response_.code) {
      notifica("success", "Los cambios se guardaron correctamente", "!Alerta");
      toggle();
    }
    setDisabled(false);
  };

  const renderChild = (node) => {
    return node.map((item, index) => {
      return (
        <>
          <Col lg={2} sm={2} md={2} />
          <Col lg={2} sm={2} md={2}>
            <div className="ckF_disable">
              <input
                type="checkbox"
                id={`check_${item.data.idVista}`}
                key={`check_item_${index}`}
                onClick={(e) => chequed_(item.data.idVista)}
                checked={values.includes(item.data.idVista)}
              />
              <label htmlFor={`check_${item.data.idVista}`}>
                <span></span>
              </label>
            </div>
          </Col>
          <Col lg={8} sm={8} md={8}>
            <span>{item.data.descripcion}</span>
          </Col>
        </>
      );
    });
  };
  const renderModules = () => {
    return tree.map((item, index) => {
      return (
        <>
          <Row>
            <Col lg={2} sm={2} md={2}>
              <div className="ckF_disable">
                <input
                  type="checkbox"
                  id={`check_${item.data.idVista}`}
                  key={`check_${index}`}
                  checked={values.includes(item.data.idVista)}
                  onClick={(e) => chequed_(item.data.idVista)}
                />
                <label htmlFor={`check_${item.data.idVista}`}>
                  <span></span>
                </label>
              </div>
            </Col>
            <Col lg={10} sm={10} md={10} className={"items_module"}>
              <span>{item.data.descripcion}</span>
            </Col>
          </Row>
          <Row>{renderChild(item.children)}</Row>
        </>
      );
    });
  };
  return (
    <div>
      <Modal isOpen={visible} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>
          {`Asignar y quitar vistas al perfil ${data.descripcion}`}{" "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              maxHeight: "350px",
              overflowY: "auto",
            }}
          >
            <Container>{tree.length > 0 ? renderModules() : null}</Container>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => OnSubmit()}
            disabled={disabled}
          >
            GUARDAR
          </Button>
          <Button color="secondary" onClick={toggle} disabled={disabled}>
            CANCELAR
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AdminVistas;
